/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var EmptyVideosIcon = createIcon("EmptyVideosIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "120",
    height: "120",
    viewBox: "0 0 120 120",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60Z",
    fill: "#CFCEFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 49a2 2 0 012 2v8.506l13.368-4.455A2 2 0 0184 56.95V75.4a2 2 0 01-2.632 1.897L68 72.84V81a2 2 0 01-2 2H26a2 2 0 01-2-2V51a2 2 0 012-2h40Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 43a2 2 0 012 2v8.506l13.368-4.455A2 2 0 0190 50.95V69.4a2 2 0 01-2.632 1.897L74 66.84V75a2 2 0 01-2 2H32a2 2 0 01-2-2V45a2 2 0 012-2h40Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 43a2 2 0 012 2v30a2 2 0 01-2 2H32a2 2 0 01-2-2V45a2 2 0 012-2h40Zm-1 2H33a1 1 0 00-1 1v28a1 1 0 001 1h38a1 1 0 001-1V46a1 1 0 00-1-1Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.897 50.316c.068.204.103.418.103.633v18.45a2 2 0 01-2.632 1.897L72 66.174v-12l15.368-5.123a2 2 0 012.53 1.265ZM87 51.66c-.101 0-.202.015-.298.045L74 55.674v9l12.702 3.968A1 1 0 0088 67.688V52.66a1 1 0 00-1-1Z",
    fill: "#0C0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 51H40a2 2 0 00-2 2v2a2 2 0 002 2h24a2 2 0 002-2v-2a2 2 0 00-2-2Z",
    fill: "#A5AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62 43v-3a1 1 0 00-1-1H43a1 1 0 110-2h19a2 2 0 012 2v4h-2Z",
    fill: "#0C0D0D"
  }));
}, {
  "i18nKey": "svg.EmptyVideosIcon"
});